import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "971569729263";
export const WHATSAPP_DISPLAY = "+971 56 972 9263";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach token from localStorage as bearer fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ayame_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
